
export const getCompletedSteps = ({completedIndex})=>{
    const initialPath = String(window.location.pathname).split('/')
    const initialPathLength = initialPath.length
    const getSwitchPath = (initialPath[initialPathLength-2]+'/'+initialPath[initialPathLength-1]) 
    if(completedIndex && typeof completedIndex == "object" && completedIndex[getSwitchPath]) return completedIndex[getSwitchPath]
    
    return []
}

export const getActiveStep = ({steps=[],pathForDevices})=>{
    
    let activeStep = 0
    const initialPath = String(window.location.pathname).split('/')
    const initialPathLength = initialPath.length
    const getSwitchPath = (initialPath[initialPathLength-2]+'/'+initialPath[initialPathLength-1]) 
    if(pathForDevices && pathForDevices[getSwitchPath] && steps.includes(pathForDevices[getSwitchPath])){
        activeStep = steps.findIndex(item=>item === pathForDevices[getSwitchPath])
    }
    return activeStep
}

